import React from 'react'
import { Switch, Route, withRouter, Redirect } from 'react-router-dom'

import Ambassadors from './../../Containers/City/Page/Ambasadors'
import AmbassadorUploadDocuments from './../../Containers/City/Page/Ambasador/UploadDocuments'
import SpyUploadDocuments from './../../Containers/City/Page/Spies/UploadDocuments'
import AmbassadorEdit from './../../Containers/City/Page/Ambasador/Edit'
import Ambassador from '../../Containers/City/Page/Ambasador/View'
import Inventory from './../../Containers/City/Page/Inventory'
import Movements from './../../Containers/City/Page/Movements'
import Locations from './../../Containers/City/Page/Locations'
import MasterSchedule from './../../Containers/City/Page/MasterSchedule'
import Pickup from './../../Containers/City/Page/Pickup'
import Spy from './../../Containers/City/Page/Spy'
import DistributionZonesPage from './../../Containers/City/Page/DistributionZonesPage'
import { CityManagerRoute, NotSpyRoute } from 'Config/Routing/auth'
import { CityEdit } from './../../Containers/City/CityEdit'
import ManagePickupTimes from './../../Containers/City/Page/PickupTimes'
import ManageOnboardingTimes from './../../Containers/City/Page/OnboardingTimes'
import LiveMap from '../../Containers/City/Page/LiveMap'

import SpyView from '../../Containers/City/Page/Spies/View'

import SpyEdit from '../../Containers/City/Page/Spies/Edit'

import { PATHS } from './../../Config/Routing/paths'
import { useCityData } from './../../Containers/City/DataHOCs/CityDataHOC'
import Mission from '../../Containers/Mission'
import StatsKPI from '../../Containers/StatsKPI/container/StatsKPI'
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator'

export const CityRouter = withRouter(props => {
  const {
    match: {
      url,
      params: { id: cityId, ambassadorId },
    },
  } = props
  const { loaded, data } = useCityData(cityId)

  return (
    <Switch>
      <Route path={url + PATHS.cities.masterSchedule}>
        <CityManagerRoute>
          {loaded ? (
            <MasterSchedule
              {...props}
              cityId={cityId}
              clients={data.clients}
              campaigns={data.campaigns}
              locations={data.locations}
              cityName={data.name}
              lunchCheckInTime={data.lunchCheckInTime}
              afternoonCheckInTime={data.afternoonCheckInTime}
              timezone={data.timezone}
              spies={data.spies}
              spySettings={data.spySettings}
              simpleCountryId={data.country.id} // Leo did this because the MasterSchedule is a mess
              countryCode={data.country.code}
            />
          ) : (
            <LoadingIndicator />
          )}
        </CityManagerRoute>
      </Route>
      <Route path={url + PATHS.cities.liveMap}>
        <NotSpyRoute>
          <CityManagerRoute>
            <LiveMap
              {...props}
              cityId={cityId}
              cityName={data.name}
              clients={data.clients}
            />
          </CityManagerRoute>
        </NotSpyRoute>
      </Route>
      <Route
        exact
        path={[
          url + PATHS.cities.availabilities,
          url + PATHS.cities.ambassadors,
          url + PATHS.cities.ambassadorsList,
          url + PATHS.cities.ambassadorsPipeline,
          url + PATHS.cities.ambassadorsEmails,
          url + PATHS.cities.ambassadorsEmailsSequence,
          url + PATHS.cities.ambassadorsEmailsStats,
          url + PATHS.cities.ambassadorsEmailsEdit,
          url + PATHS.cities.ambassadorsEmailsCreate,
        ]}
      >
        <CityManagerRoute>
          <Ambassadors
            {...props}
            cityId={cityId}
            newcomersMissionsLimit={data.newcomersMissionsLimit}
            recruitmentOnHold={data.recruitmentOnHold}
            cityName={data.name}
            countryName={data.country.name}
            countryId={data.country.id}
            cityEmail={data.recruitmentCalendarId}
            countryCode={data.country && data.country.code}
            cityTimezone={data.timezone}
            isOnsiteTrainingEnabled={data.isOnsiteTrainingEnabled}
          />
        </CityManagerRoute>
      </Route>
      <Route exact path={url + PATHS.cities.missionView}>
        <CityManagerRoute>
          <Mission {...props} />
        </CityManagerRoute>
      </Route>
      <Route exact path={url + PATHS.cities.missionEdit}>
        <CityManagerRoute>
          <Mission {...props} editMode />
        </CityManagerRoute>
      </Route>
      <Route
        exact
        path={[
          url + PATHS.cities.pickup,
          url + PATHS.cities.pickupAll,
          url + PATHS.cities.pickupBrief,
        ]}
      >
        <CityManagerRoute>
          <Pickup
            {...props}
            cityName={data.name}
            cityDataLoaded={loaded}
            cityId={cityId}
            clients={data.clients}
            campaigns={data.campaigns}
          />
        </CityManagerRoute>
      </Route>
      <Route path={url + PATHS.cities.stats}>
        <NotSpyRoute>
          <CityManagerRoute>
            <StatsKPI
              {...props}
              cityId={cityId}
              clients={data.clients}
              campaigns={data.campaigns}
              locations={data.locations}
              cityName={data.name}
            />
          </CityManagerRoute>
        </NotSpyRoute>
      </Route>
      <Route path={url + PATHS.cities.locations}>
        <CityManagerRoute>
          <Locations
            {...props}
            cityDataLoaded={loaded}
            cityId={cityId}
            cityName={data.name}
            countryCode={data.country && data.country.code}
            cityCenterLocation={data.cityCenterLocation}
          />
        </CityManagerRoute>
      </Route>
      <Route exact path={url + PATHS.cities.ambassador}>
        <CityManagerRoute>
          <Ambassador
            {...props}
            ambassadorId={ambassadorId}
            cityName={data.name}
          />
        </CityManagerRoute>
      </Route>

      <Route exact path={url + PATHS.cities.spies}>
        <CityManagerRoute>
          <SpyView {...props} cityName={data.name} />
        </CityManagerRoute>
      </Route>

      <Route exact path={url + PATHS.cities.spiesEdit}>
        <CityManagerRoute>
          <SpyEdit {...props} />
        </CityManagerRoute>
      </Route>

      <Route exact path={url + PATHS.cities.spyUploadDocuments}>
        <CityManagerRoute>
          <SpyUploadDocuments {...props} countryCode={data.country.code} />
        </CityManagerRoute>
      </Route>

      <Route exact path={url + PATHS.cities.ambassadorEdit}>
        <CityManagerRoute>
          <AmbassadorEdit {...props} />
        </CityManagerRoute>
      </Route>
      <Route exact path={url + PATHS.cities.ambassadorUploadDocuments}>
        <CityManagerRoute>
          <AmbassadorUploadDocuments
            {...props}
            countryCode={data.country.code}
          />
        </CityManagerRoute>
      </Route>
      <Route exact path={PATHS.cities.inventory}>
        <CityManagerRoute>
          <Inventory cityName={data.name} />
        </CityManagerRoute>
      </Route>
      <Route exact path={PATHS.cities.movements}>
        <CityManagerRoute>
          <Movements cityName={data.name} cityTimezone={data.timezone} />
        </CityManagerRoute>
      </Route>
      <Route path={url + PATHS.cities.edit}>
        <CityManagerRoute>
          <CityEdit
            {...props}
            cityId={cityId}
            cityDataLoaded={loaded}
            cityName={data.name}
          />
        </CityManagerRoute>
      </Route>
      <Route path={url + PATHS.cities.managePickupTimes}>
        <CityManagerRoute>
          <ManagePickupTimes {...props} cityId={cityId} cityName={data.name} />
        </CityManagerRoute>
      </Route>
      <Route path={url + PATHS.cities.manageOnboardingTimes}>
        <CityManagerRoute>
          <ManageOnboardingTimes
            {...props}
            cityId={cityId}
            cityName={data.name}
            countryCode={data.country && data.country.code}
          />
        </CityManagerRoute>
      </Route>
      <Route path={url + PATHS.cities.spy}>
        <CityManagerRoute>
          <Spy
            {...props}
            cityName={data.name}
            cityDataLoaded={loaded}
            cityId={cityId}
            clients={data.clients}
            campaigns={data.campaigns}
            cityEmail={data.recruitmentCalendarId}
          />
        </CityManagerRoute>
      </Route>
      <Route path={url + PATHS.cities.distributionZones}>
        <CityManagerRoute>
          {loaded ? (
            <DistributionZonesPage
              {...props}
              country={data.country}
              cityName={data.name}
              cityId={cityId}
            />
          ) : (
            <LoadingIndicator />
          )}
        </CityManagerRoute>
      </Route>
      <Redirect from={url} to={url + PATHS.cities.masterSchedule} />
    </Switch>
  )
})
